import domToImage from "dom-to-image";
import React, { useEffect, useRef, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import { SketchPicker } from "react-color";
import Draggable from "react-draggable";
import Cropper from "react-easy-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LeftArrow from "../../assets/svg/LeftArrow.svg";
import RightArrow from "../../assets/svg/arrow-right-line.svg";
import threeDot from "../../assets/svg/more-2-fill.svg";
import music from "../../assets/svg/music-fill.svg";
import text from "../../assets/svg/text.svg";
import getAdjustmentImg from "../Stories/crop/adjustmentImage";
import getCroppedImg from "../Stories/crop/cropImage";
import getFilterImg from "../Stories/crop/filterImage";
import getMirrorImg from "../Stories/crop/mirrorImage";
import { IoMdRefresh } from "react-icons/io";
import styles from "./PostWrapper.module.scss";

export const PostCrop = ({ imagesArray, setImagesArray, setCropContShow, setSelectedImageShow, setUploadSection }) => {
	const { userId } = useSelector((state) => state.auth);
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(1);
	const [rotation, setRotation] = useState(0);
	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

	const [cropShow, setCropShow] = useState(false);
	const [rotateShow, setRotateShow] = useState(false);
	const [aspectRatioShow, setAspectRatioShow] = useState(false);
	const [aspectValue, setAspectValue] = useState(1 / 1);

	const [effectShow, setEffectShow] = useState(false);
	const [effectValue, setEffectValue] = useState(styles.EffectNormal);
	const [adjustmentShow, setAdjustmentShow] = useState(false);
	const [adjustmentValue, setAdjustmentValue] = useState({
		contrast: 100,
		brightness: 100,
		saturate: 100,
		huerotate: 0,
		sepia: 0,
		invert: 0,
		grayscale: 0,
		blur: 0,
	});

	const [textShow, setTextShow] = useState(false);
	const inputRef = useRef(null);
	const [draggable, setDraggable] = useState(false);
	const [fontSize, setFontSize] = useState(10);
	const [textRotation, setTextRotation] = useState(0);
	const [isMouseDown, setIsMouseDown] = useState(false);
	const [fontFamily, setFontFamily] = useState("Poppins");
	const [colorPicker, setColorPicker] = useState(false);
	const [bgColor, setBgColor] = useState({ r: 0, g: 0, b: 0, a: 1 });

	const [mirrorShow, setMirrorShow] = useState(false);
	const [mirrorValueX, setMirrorValueX] = useState(1);
	const [mirrorValueY, setMirrorValueY] = useState(1);

	const [imageWidth, setImageWidth] = useState(100);
	const [imageHeight, setImageHeight] = useState(100);
	const [activeIndex, setActiveIndex] = useState(0);
	const [activeImageURL, setActiveImageURL] = useState("");
	const [updatedImagesArray, setUpdatedImagesArray] = useState([]);

	const responsive = {
		0: {
			items: 2,
		},
		500: {
			items: 4,
		},
		600: {
			items: 5,
		},
		// 700: {
		// 	items: 6,
		// },
		// 800: {
		// 	items: 7,
		// },
		// 1024: {
		// 	items: 8,
		// },
	};

	const UpdateImageArrayWithNewData = async (file) => {
		const newArray = [...updatedImagesArray];
		newArray[activeIndex] = file;
		setUpdatedImagesArray(newArray);
	};

	const cropImage = async () => {
		try {
			const { file, url } = await getCroppedImg(activeImageURL, croppedAreaPixels, rotation);
			setActiveImageURL(url);
			setCropShow(false);
			setRotation(0);
			setAspectValue(1 / 1);
			UpdateImageArrayWithNewData(file);
		} catch (error) {
			console.log(error);
		}
	};

	const handelMirror = async () => {
		try {
			const { file, url } = await getMirrorImg(activeImageURL, mirrorValueX, mirrorValueY);
			setActiveImageURL(url);
			UpdateImageArrayWithNewData(file);
			setMirrorShow(false);
			setMirrorValueX(1);
			setMirrorValueY(1);
		} catch (error) {
			console.log(error);
		}
	};

	const handelFilter = async () => {
		try {
			const { file, url } = await getFilterImg(activeImageURL, effectValue);
			setActiveImageURL(url);
			UpdateImageArrayWithNewData(file);

			setEffectShow(false);
			setEffectValue(styles.EffectNormal);
		} catch (error) {
			console.log(error);
		}
	};

	const handelAdjustment = async () => {
		try {
			const { file, url } = await getAdjustmentImg(activeImageURL, adjustmentValue);
			setActiveImageURL(url);
			UpdateImageArrayWithNewData(file);

			setAdjustmentShow(false);
			setAdjustmentValue({
				contrast: 100,
				brightness: 100,
				saturate: 100,
				huerotate: 0,
				sepia: 0,
				invert: 0,
				grayscale: 0,
				blur: 0,
			});
		} catch (error) {
			console.log(error);
		}
	};

	const handelTextAdd = () => {
		if (inputRef.current) {
			inputRef.current.blur();
			inputRef.current.style.outline = "none";
			inputRef.current.style.resize = "none";
		}

		const MainEffectImage = document.getElementById("MainEffectImage");

		if (MainEffectImage) {
			domToImage
				.toPng(MainEffectImage)
				.then(function (dataUrl) {
					fetch(dataUrl)
						.then((res) => res.blob())
						.then((blob) => {
							const file = new File([blob], "Effect", { type: "image/png" });
							setActiveImageURL(URL.createObjectURL(file));
							UpdateImageArrayWithNewData(file);

							setTextShow(false);
							setDraggable(false);
							setTextRotation(0);
						});
				})
				.catch(function (error) {
					console.error("Error converting textarea to image:", error);
				});
		}
	};

	const onImageLoad = (e) => {
		setImageWidth(e.target.width);
		setImageHeight(e.target.height);

		// const { naturalWidth: width, naturalHeight: height } = e.currentTarget;
		// const crop = centerCrop(
		// 	makeAspectCrop(
		// 		{
		// 			unit: "%",
		// 			width: 90,
		// 			height: 50,
		// 		},
		// 		16 / 9,
		// 		width,
		// 		height
		// 	),
		// 	width,
		// 	height
		// );

		// setCroppedAreaPixels(crop);
	};

	const handelRemoveImage = (indexToRemove) => {
		const updatedArray1 = imagesArray.filter((_, index) => index !== indexToRemove);
		const updatedArray2 = updatedImagesArray.filter((_, index) => index !== indexToRemove);
		setImagesArray(updatedArray1);
		setUpdatedImagesArray(updatedArray2);

		if (activeIndex === 0 && updatedArray2.length > 0) setActiveIndex(0);
		else setActiveIndex(activeIndex - 1);

		if (updatedArray2.length === 0) {
			setCropContShow(false);
			setSelectedImageShow(true);
		}
	};

	useEffect(() => {
		setUpdatedImagesArray(imagesArray);
	}, []);

	useEffect(() => {
		if (updatedImagesArray.length === 0) return;
		const currentMedia = updatedImagesArray[activeIndex];
		setActiveImageURL(currentMedia instanceof Blob ? URL.createObjectURL(currentMedia) : currentMedia);
	}, [activeIndex, updatedImagesArray]);

	useEffect(() => {
		if (textShow) inputRef?.current?.focus();
	}, [textShow]);

	useEffect(() => {
		if (draggable) inputRef?.current?.blur();
		else inputRef?.current?.focus();
	}, [draggable]);

	const navigate = useNavigate();


	const handelRightArrow = () => {
		setCropContShow(false);
		navigate("/UploadPost", {
			state: {
				fileData: updatedImagesArray.length === 1 ? updatedImagesArray[0] : updatedImagesArray,
				caption: "",
			},
		});
	};

	return (
		<div className={styles.CropperMainWrapper}>
			<div className={styles.controlsBar}>
				<div className={styles.Left}>
					<img
						src={LeftArrow}
						alt="Back"
						className={styles.PopupCloseBtn}
						onClick={() => {
							setSelectedImageShow(true);
							setCropContShow(false);
						}}
					/>
					<img
						src={threeDot}
						alt="Options"
						onClick={() => {
							toast.info("Options Coming Soon...");
						}}
					/>
					<img src={text} alt="Text" onClick={() => setTextShow(!textShow)} />
					<img
						src={music}
						alt="Music"
						onClick={() => {
							toast.info("Music Coming Soon...");
						}}
					/>
					<IoMdRefresh
						className={styles.ResetBtnHeader}
						onClick={() => {
							setEffectValue(styles.EffectNormal);
							setAdjustmentValue({
								contrast: 100,
								brightness: 100,
								saturate: 100,
								huerotate: 0,
								sepia: 0,
								invert: 0,
								grayscale: 0,
								blur: 0,
							});
							setMirrorValueX(1);
							setMirrorValueY(1);
							toast.info("Adjustments Reset");
						}}
						title="Reset all adjustments"
					/>
				</div>
				<div className={styles.NextIconWrapper}>
					<img src={RightArrow} alt="Next" className={styles.NextArrowBtn} onClick={handelRightArrow} />
				</div>
			</div>

			<div className={styles.CropContainer}>
				{!effectShow && !adjustmentShow && !cropShow && !textShow && !mirrorShow && (
					<>
						{activeIndex > 0 && (
							<button
								className={styles.LeftBtn}
								onClick={() => {
									if (activeIndex > 0) setActiveIndex(activeIndex - 1);
								}}>
								<img src={LeftArrow} alt="Prev" />
							</button>
						)}

						{activeIndex < imagesArray.length - 1 && (
							<button
								className={styles.RightBtn}
								onClick={() => {
									if (activeIndex < imagesArray.length - 1) setActiveIndex(activeIndex + 1);
								}}>
								<img src={RightArrow} alt="Next" />
							</button>
						)}
					</>
				)}

				{effectShow || adjustmentShow || textShow || mirrorShow ? (
					<div className={styles.EffectPreview} id="MainEffectImage" style={{ width: imageWidth, height: imageHeight }}>
						<img
							src={activeImageURL}
							alt=""
							className={`${styles.img} ${adjustmentShow ? "" : effectValue}`}
							style={{
								filter: adjustmentShow
									? `contrast(${adjustmentValue.contrast}%) brightness(${adjustmentValue.brightness}%) saturate(${adjustmentValue.saturate}%) hue-rotate(${adjustmentValue.huerotate}deg) sepia(${adjustmentValue.sepia}%) invert(${adjustmentValue.invert}%) grayscale(${adjustmentValue.grayscale}%) blur(${adjustmentValue.blur}px)`
									: "",
								transform: `scale(${mirrorValueX},${mirrorValueY})`,
								opacity: `${adjustmentValue.opacity || 1}`,
							}}
						/>
						{textShow && (
							<Draggable onStart={() => draggable}>
								<div>
									<textarea
										ref={inputRef}
										className={styles.TextArea}
										readOnly={draggable}
										onClick={() => {
											setColorPicker(false);
										}}
										onKeyDown={(e) => {
											if (e.key === "Control") setDraggable(true);
											else setDraggable(false);
										}}
										onKeyUp={(e) => {
											setDraggable(false);
										}}
										style={{
											cursor: draggable ? "grabbing" : "text",
											resize: draggable ? "none" : "both",
											fontSize: `${fontSize}px`,
											transform: `rotate(${textRotation}deg)`,
											color: `rgba(${bgColor.r},${bgColor.g},${bgColor.b},${bgColor.a})`,
										}}></textarea>
								</div>
							</Draggable>
						)}
					</div>
				) : (cropShow || rotateShow) ? (
					<Cropper
						image={activeImageURL}
						crop={crop}
						zoom={zoom}
						rotation={rotation}
						aspect={aspectValue}
						onZoomChange={setZoom}
						onRotationChange={setRotation}
						onCropChange={setCrop}
						onCropComplete={(croppedArea, croppedAreaPixels) => setCroppedAreaPixels(croppedAreaPixels)}
					/>
				) : (
					<img src={activeImageURL} onLoad={onImageLoad} className={styles.img} alt="Preview" />
				)}
			</div>

			<div className={styles.BottomWrapper}>
				{!effectShow && !adjustmentShow && !cropShow && !textShow && !mirrorShow && !rotateShow && (
					<button className={styles.RemoveBtn} onClick={() => handelRemoveImage(activeIndex)}>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
						Remove
					</button>
				)}

				{!effectShow && !cropShow && !rotateShow && !aspectRatioShow && !adjustmentShow && !textShow && !mirrorShow && (
					<div className={styles.ButtonWrapper}>
						<button onClick={() => setRotateShow(true)} className={styles.ToolBtn}>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"></path><path d="M16 16h5v5"></path></svg>
							Rotate
						</button>
						<button onClick={() => setCropShow(true)} className={styles.ToolBtn}>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path></svg>
							Crop
						</button>
						<button onClick={() => setAdjustmentShow(true)} className={styles.ToolBtn}>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="2" x2="12" y2="22"></line><path d="M12 22a7 7 0 0 0 7-7V9a7 7 0 0 0-7-7"></path></svg>
							Adjustment
						</button>
						<button onClick={() => setEffectShow(true)} className={styles.ToolBtn}>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
							Effects
						</button>
						<button onClick={() => toast.info("Collage Coming Soon...")} className={styles.ToolBtn}>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
							Collage
						</button>
					</div>
				)}

				{cropShow && !rotateShow && !aspectRatioShow && (
					<div className={styles.CropWrapper}>
						<div className={styles.Left}>
							<button onClick={() => setAspectRatioShow(true)}>Aspect Ratio</button>
						</div>

						<div className={styles.Right}>
							<button
								className={styles.GoBtn}
								onClick={() => {
									setCropShow(false);
									cropImage();
								}}>
								Apply
							</button>
							<button
								className={styles.CancelBtn}
								onClick={() => {
									setCropShow(false);
								}}>
								Cancel
							</button>
						</div>
					</div>
				)}

				{rotateShow && (
					<div className={styles.RotateWrapper}>
						<div className={styles.Left}>
							<div className={styles.ControlItem}>
								<span>Zoom: {Math.round(zoom * 100)}%</span>
								<input
									type="range"
									value={zoom}
									step={0.1}
									min={1}
									max={3}
									onChange={(e) => setZoom(parseFloat(e.target.value))}
								/>
							</div>
							<div className={styles.ControlItem}>
								<span>Rotation: {rotation}°</span>
								<input
									type="range"
									value={rotation}
									step={1}
									min={0}
									max={360}
									onChange={(e) => setRotation(parseInt(e.target.value))}
								/>
							</div>
						</div>

						<div className={styles.Right}>
							<button
								className={styles.GoBtn}
								onClick={() => {
									setRotateShow(false);
									cropImage();
								}}>
								Apply
							</button>
							<button
								className={styles.CancelBtn}
								onClick={() => {
									setRotateShow(false);
									setRotation(0);
									setZoom(1);
								}}>
								Cancel
							</button>
						</div>
					</div>
				)}

				{aspectRatioShow && (
					<div className={styles.AspectRatioWrapper}>
						<div className={styles.Left}>
							<button onClick={() => setAspectValue(undefined)}>Original</button>
							<button onClick={() => setAspectValue(1 / 1)}>1 : 1</button>
							<button onClick={() => setAspectValue(1 / 2)}>1 : 2</button>
							<button onClick={() => setAspectValue(2 / 1)}>2 : 1</button>
							<button onClick={() => setAspectValue(4 / 5)}>4 : 5</button>
							<button onClick={() => setAspectValue(5 / 4)}>5 : 4</button>
							<button onClick={() => setAspectValue(16 / 9)}>16 : 9</button>
						</div>

						<div className={styles.Right}>
							<button
								onClick={() => {
									setAspectRatioShow(false);
								}}>
								Go
							</button>
							<button
								onClick={() => {
									setAspectRatioShow(false);
									setAspectValue(1 / 1);
								}}>
								Cancel
							</button>
						</div>
					</div>
				)}

				{effectShow && (
					<div className={styles.EffectShowWrapper}>
						<div className={styles.Left}>
							<div className={styles.FilterList}>
								<div
									className={styles.ImageWrapper}
									onClick={() => {
										setEffectValue(styles.EffectNormal);
										UpdateImageArrayWithNewData(imagesArray[activeIndex]);
									}}>
									<img src={activeImageURL} alt="" className={styles.EffectNormal} />
									<p>Normal</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.Effect1977)}>
									<img src={activeImageURL} alt="" className={styles.Effect1977} />
									<p>1977</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectAden)}>
									<img src={activeImageURL} alt="" className={styles.EffectAden} />
									<p>Aden</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectAmaro)}>
									<img src={activeImageURL} alt="" className={styles.EffectAmaro} />
									<p>Amaro</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectBrannan)}>
									<img src={activeImageURL} alt="" className={styles.EffectBrannan} />
									<p>Brannan</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectBrooklyn)}>
									<img src={activeImageURL} alt="" className={styles.EffectBrooklyn} />
									<p>Brooklyn</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectClarendon)}>
									<img src={activeImageURL} alt="" className={styles.EffectClarendon} />
									<p>Clarendon</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectEarlybird)}>
									<img src={activeImageURL} alt="" className={styles.EffectEarlybird} />
									<p>Earlybird</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectGingham)}>
									<img src={activeImageURL} alt="" className={styles.EffectGingham} />
									<p>Gingham</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectHudson)}>
									<img src={activeImageURL} alt="" className={styles.EffectHudson} />
									<p>Hudson</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectInkwell)}>
									<img src={activeImageURL} alt="" className={styles.EffectInkwell} />
									<p>Inkwell</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectLofi)}>
									<img src={activeImageURL} alt="" className={styles.EffectLofi} />
									<p>Lofi</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectMaven)}>
									<img src={activeImageURL} alt="" className={styles.EffectMaven} />
									<p>Maven</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectPerpetua)}>
									<img src={activeImageURL} alt="" className={styles.EffectPerpetua} />
									<p>Perpetua</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectReyes)}>
									<img src={activeImageURL} alt="" className={styles.EffectReyes} />
									<p>Reyes</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectStinson)}>
									<img src={activeImageURL} alt="" className={styles.EffectStinson} />
									<p>Stinson</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectToaster)}>
									<img src={activeImageURL} alt="" className={styles.EffectToaster} />
									<p>Toaster</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectWalden)}>
									<img src={activeImageURL} alt="" className={styles.EffectWalden} />
									<p>Walden</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectValencia)}>
									<img src={activeImageURL} alt="" className={styles.EffectValencia} />
									<p>Valencia</p>
								</div>

								<div
									className={styles.ImageWrapper}
									onClick={() => setEffectValue(styles.EffectXpro2)}>
									<img src={activeImageURL} alt="" className={styles.EffectXpro2} />
									<p>Xpro2</p>
								</div>
							</div>
						</div>

						<div className={styles.Right}>
							<button onClick={handelFilter}>Go</button>
							<button
								onClick={() => {
									setEffectShow(false);
									setEffectValue(styles.EffectNormal);
								}}>
								Cancel
							</button>
						</div>
					</div>
				)}

				{adjustmentShow && (
					<div className={styles.AdjustmentWrapper}>
						<div className={styles.Left}>
							<div className={styles.RangeMainWrapper}>
								<div className={styles.RangeWrapper}>
									<label htmlFor="Contrast">Contrast : </label>
									<input
										type="range"
										id="Contrast"
										min={0}
										max={300}
										value={adjustmentValue.contrast}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, contrast: e.target.value })}
									/>
									<span>{adjustmentValue.contrast}</span>
								</div>

								<div className={styles.RangeWrapper}>
									<label htmlFor="Saturate">Saturate : </label>
									<input
										type="range"
										id="Saturate"
										min={0}
										max={300}
										value={adjustmentValue.saturate}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, saturate: e.target.value })}
									/>
									<span>{adjustmentValue.saturate}</span>
								</div>

								<div className={styles.RangeWrapper}>
									<label htmlFor="Brightness">Brightness : </label>
									<input
										type="range"
										id="Brightness"
										min={0}
										max={300}
										value={adjustmentValue.brightness}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, brightness: e.target.value })}
									/>
									<span>{adjustmentValue.brightness}</span>
								</div>

								<div className={styles.RangeWrapper}>
									<label htmlFor="grayscale">Grayscale : </label>
									<input
										type="range"
										id="grayscale"
										min={0}
										max={100}
										value={adjustmentValue.grayscale}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, grayscale: e.target.value })}
									/>
									<span>{adjustmentValue.grayscale}</span>
								</div>
							</div>

							<div className={styles.RangeMainWrapper}>
								<div className={styles.RangeWrapper}>
									<label htmlFor="sepia">Sepia : </label>
									<input
										type="range"
										id="sepia"
										min={0}
										max={100}
										value={adjustmentValue.sepia}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, sepia: e.target.value })}
									/>
									<span>{adjustmentValue.sepia}</span>
								</div>

								<div className={styles.RangeWrapper}>
									<label htmlFor="invert">Invert : </label>
									<input
										type="range"
										id="invert"
										min={0}
										max={100}
										value={adjustmentValue.invert}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, invert: e.target.value })}
									/>
									<span>{adjustmentValue.invert}</span>
								</div>

								<div className={styles.RangeWrapper}>
									<label htmlFor="huerotate">HueRotate : </label>
									<input
										type="range"
										id="huerotate"
										min={0}
										max={360}
										value={adjustmentValue.huerotate}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, huerotate: e.target.value })}
									/>
									<span>{adjustmentValue.huerotate}</span>
								</div>

								<div className={styles.RangeWrapper}>
									<label htmlFor="blur">Blur : </label>
									<input
										type="range"
										id="blur"
										min={0}
										max={10}
										value={adjustmentValue.blur}
										onChange={(e) => setAdjustmentValue({ ...adjustmentValue, blur: e.target.value })}
									/>
									<span>{adjustmentValue.blur}</span>
								</div>
							</div>
						</div>

						<div className={styles.Right}>
							<button onClick={handelAdjustment}>Go</button>
							<button
								onClick={() => {
									setAdjustmentShow(false);
									setAdjustmentValue({
										contrast: 100,
										brightness: 100,
										saturate: 100,
										huerotate: 0,
										sepia: 0,
										invert: 0,
										grayscale: 0,
										blur: 0,
									});
								}}>
								Cancel
							</button>
						</div>
					</div>
				)}

				{textShow && (
					<div className={styles.TextWrapper}>
						<div className={styles.Left}>
							<button onClick={() => setDraggable(!draggable)} className={styles.draggableBtn}>
								{draggable ? "Drag End" : "Drag Start"}
							</button>

							<select
								onChange={(e) => setFontSize(e.target.value)}
								defaultValue={fontSize}
								className={styles.fontSizeBtn}>
								<option value="10">10</option>
								<option value="15">15</option>
								<option value="20">20</option>
								<option value="25">25</option>
								<option value="30">30</option>
								<option value="35">35</option>
								<option value="40">40</option>
								<option value="45">45</option>
								<option value="50">50</option>
								<option value="55">55</option>
							</select>

							<input
								type="range"
								min={-180}
								max={180}
								className={styles.rangeBtn}
								value={textRotation}
								onChange={(e) => setTextRotation(e.target.value)}
							/>

							<button
								className={styles.ColorBallBtn}
								style={{
									background: `rgba(${bgColor.r},${bgColor.g},${bgColor.b},${bgColor.a})`,
								}}
								onClick={() => setColorPicker(!colorPicker)}>
								{colorPicker && (
									<div className={styles.ColorPicker} onClick={(e) => e.stopPropagation()}>
										<SketchPicker color={bgColor} onChange={(e) => setBgColor(e.rgb)} />
									</div>
								)}
							</button>
						</div>

						<div className={styles.Right}>
							<button onClick={handelTextAdd}>Go</button>
							<button
								onClick={() => {
									setTextShow(false);
								}}>
								Cancel
							</button>
						</div>
					</div>
				)}

				{mirrorShow && (
					<div className={styles.MirrorWrapper}>
						<div className={styles.Left}>
							<button
								onClick={() => {
									if (mirrorValueX === 1) setMirrorValueX(-1);

									if (mirrorValueX === -1) setMirrorValueX(1);
								}}>
								Rotate-X
							</button>
							<button
								onClick={() => {
									if (mirrorValueY === 1) setMirrorValueY(-1);
									if (mirrorValueY === -1) setMirrorValueY(1);
								}}>
								Rotate-Y
							</button>
							<button
								onClick={() => {
									setMirrorValueX(1);
									setMirrorValueY(1);
								}}>
								Reset
							</button>
						</div>

						<div className={styles.Right}>
							<button onClick={handelMirror}>Go</button>
							<button
								onClick={() => {
									setMirrorShow(false);
								}}>
								cancel
							</button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};


